import initSearchResultsPage from "./search-page";

export default initSearchResultsPage;
